import script from "./AuraChartBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraChartBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AuraChartBlock.vue?vue&type=style&index=0&id=5c0b2d54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0b2d54"]])

export default __exports__